import { useFragmentFromStore } from '@smx-ui-model/hooks/use-fragment-from-store';
import { StoreModelType } from '@smx-ui-model/types';
import { Checkbox } from 'antd';
import * as React from 'react';

import { EntityTableRowSetColumn } from './entity-table-row-set-column';

interface EntityTableRowProps<C> {
    modelName: keyof StoreModelType;
    node?: any;
    isCheckBoxColumn?: boolean;
    setSelectedRows?: React.Dispatch<React.SetStateAction<string[]>>;
    selectedRows?: string[];
    contextName?: C;
}

export const EntityTableRow = <C,>({
    modelName,
    isCheckBoxColumn,
    setSelectedRows,
    selectedRows = [],
    node,
    contextName,
    ...rest
}: EntityTableRowProps<C>) => {
    const [isMouseOver, setMouseOver] = React.useState(false);
    const dataEntity = useFragmentFromStore<any>(node);

    const getColor = () => {
        if (isMouseOver) {
            return selectedRows.includes(dataEntity.id) ? '#bae0ff' : '#fcfcfc';
        }

        return selectedRows.includes(dataEntity.id) ? '#e6f4ff' : 'white';
    };

    return (
        <tr
            {...rest}
            style={{ cursor: 'pointer', backgroundColor: getColor() }}
            onMouseOver={() => {
                setMouseOver(true);
            }}
            onMouseLeave={() => {
                setMouseOver(false);
            }}
        >
            {isCheckBoxColumn && (
                <td style={{ textAlign: 'center' }}>
                    {
                        <Checkbox
                            onClick={(e) => e.stopPropagation()}
                            checked={selectedRows.includes(dataEntity.id)}
                            onChange={(value) => {
                                if (value.target.checked) {
                                    setSelectedRows?.((previousValue) => {
                                        return [...previousValue, dataEntity.id];
                                    });
                                } else {
                                    setSelectedRows?.((previousValue) => {
                                        return previousValue.filter((id) => id !== dataEntity.id);
                                    });
                                }
                            }}
                        />
                    }
                </td>
            )}
            <EntityTableRowSetColumn node={node} contextName={contextName} modelName={modelName} />
        </tr>
    );
};
